import {useState} from 'react';
import styles from '../../style.module.scss';
import {formatNumber} from '@/utils/number';
import {CurrentPageStore} from '@/store/content-optimizer/currentPage';
import {SuggestedKeywordType} from '@/store/content-optimizer/SuggestedKeywordsModel';
import {
  Tooltip,
} from 'antd';
import {observer} from 'mobx-react';


import {MixPanel} from '@/utils/mixpanel';
import {SCA_PAGE_ADD_KEYWORD_SUGGESTION} from '@/constants/events';
import {useStore} from '@/store/root-store';

interface Props {
  kw: SuggestedKeywordType;
  store: CurrentPageStore;
  getCustomerQuota?: () => {};
  showSidebarPaymentDrawer?: any;
  quotaUtilization?: any;
}

export const SuggestedKeywordCard = observer(({kw, store, getCustomerQuota, showSidebarPaymentDrawer, quotaUtilization}: Props) => {
  const {contentOptimizer: {currentPage: {isPublic}}} = useStore('');
  const [isRemoving, setIsRemoving] = useState(false);


  const addSuggestedKwToTargetKw = async (passedKw: string) => {
    if (!passedKw) return;
    if (!store.feTargetKeywords || store.feTargetKeywords?.length >= 15) return;
    if (store.feTargetKeywords?.filter(kw => kw.keyword === passedKw).length > 0) {
      return;
    }

    let stagedForAddingKw;

    if (store.content.locationId && store.content.location) {
      stagedForAddingKw = {
        keyword: passedKw,
        countryCode: '',
        locationId: store.content.locationId,
        location: store.content.location,
      };
    } else if (store.content.countryCode) {
      stagedForAddingKw = {
        keyword: passedKw,
        countryCode: store.content.countryCode,
        locationId: null,
        location: null,
      };
    } else if (!store.content.locationId && !store.content.countryCode) {
      stagedForAddingKw = {
        keyword: passedKw,
        countryCode: '',
        locationId: null,
        location: null,
      };
    }
    const formatArray = [...store.feTargetKeywords, stagedForAddingKw];

    store.updateFeTargetKeywords(formatArray);

    try {
      await store?.editKeywords(stagedForAddingKw, 'add');
      getCustomerQuota();
    } catch (err) {
      if (err?.response?.status === 429) {
        showSidebarPaymentDrawer(null, {title: 'You need more Content Genius focus terms quota to continue', subtitle: '', text: `Current limit: ${quotaUtilization?.ca?.allowedFocusTerms?.total} lookups`});
      }
      return Promise.reject(err);
    }


    MixPanel.track(SCA_PAGE_ADD_KEYWORD_SUGGESTION, {
      'suggestedKeyword': passedKw,
      'description': 'Added new keyword suggestion',
    });
  };

  const removeTargetKeyword = (passedKw: string) => {
    store.removeSuggestedKeyword(passedKw);
  };

  return <div className={styles.singleSuggestedKwContainer} style={{maxWidth: isRemoving && '0'}}>
    <Tooltip placement='bottomRight' title={<>
      {store.feTargetKeywords?.length >= 15 && <div style={{marginBottom: 10}}>{`You've reached the maximum number of 15 target keywords per article.`}</div>}
      <div className={styles.tooltipInner}>
        {`Search Volume: ${formatNumber(kw.sv)}`}<br />
        {`Cost per Click: $${Math.round(kw.cpc)}`}
      </div>
    </>}>
      <div className={styles.singleSugestedKwInnerContainer} onClick={() => isPublic ? {} : addSuggestedKwToTargetKw(kw.keyword)}>
        <div className={styles.suggestedKWTitleContainer} onClick={() => isPublic ? {} : addSuggestedKwToTargetKw(kw.keyword)}>
          <div className={styles.suggestedKwTitle}> {kw.keyword} </div>

          {/* <span className={styles.svAndCpc}>{formatNumber(kw.sv)} ‧ ${Math.round(kw.cpc)}</span> */}
          {!isPublic &&
            <div className={styles.controllsBar}>

              <span className={styles.clickToAdd}><strong><span style={{marginRight: '3px'}}> {('+')}</span></strong>{('Add')}</span>
              <span className={styles.closeSuggestedKW} onClick={(e: any) => {
                e.stopPropagation();
                setIsRemoving(true);
                removeTargetKeyword(kw.keyword);
              }}>x</span>
            </div>}
        </div>
      </div>
    </Tooltip>
  </div>;
});
